/**
 * 修复：将函数挂载到 window.crbChangeSlide 以确保全局 onclick 可调用
 */
window.crbChangeSlide = function(sid, index) {
  const container = document.getElementById('crb-' + sid);
  if (!container) return;

  const slides = container.querySelectorAll('.crb-slide');
  const dots = container.querySelectorAll('.crb-dot');
  
  let currentActive = 0;
  slides.forEach((s, i) => { if(s.classList.contains('active')) currentActive = i; });

  // 停止旧视频
  const oldVideo = slides[currentActive].querySelector('video');
  if (oldVideo) oldVideo.pause();

  slides[currentActive].classList.remove('active');
  if (dots[currentActive]) dots[currentActive].classList.remove('active');

  const nextIndex = (index + slides.length) % slides.length;
  slides[nextIndex].classList.add('active');
  if (dots[nextIndex]) dots[nextIndex].classList.add('active');

  // 播放新视频
  const newVideo = slides[nextIndex].querySelector('video');
  if (newVideo) {
    newVideo.currentTime = 0;
    newVideo.play().catch(() => {});
  }

  // 通知自动播放重置计时
  container.dispatchEvent(new CustomEvent('crbSlideUpdate', { detail: { index: nextIndex } }));
};

/**
 * 左右箭头切换逻辑
 * @param {string} sid - Section ID
 * @param {number} direction - 方向: 1 为下一张, -1 为上一张
 */
window.crbPrevNext = function(sid, direction) {
  const container = document.getElementById('crb-' + sid);
  if (!container) return;

  const slides = container.querySelectorAll('.crb-slide');
  let currentIndex = 0;

  // 寻找当前 active 的索引
  slides.forEach((slide, index) => {
    if (slide.classList.contains('active')) {
      currentIndex = index;
    }
  });

  // 计算目标索引（循环逻辑）
  let targetIndex = (currentIndex + direction + slides.length) % slides.length;

  // 调用你原有的切换函数
  window.crbChangeSlide(sid, targetIndex);
};

(function() {
  const init = () => {
    document.querySelectorAll('.crb-container').forEach(container => {
      const sectionId = container.id.replace('crb-', '');
      const isAutoPlay = container.getAttribute('data-autoplay') === 'true';
      const speed = parseInt(container.getAttribute('data-speed')) || 7000;
      let interval;
      let currentIndex = 0;

      const startTimer = () => {
        if (!isAutoPlay || container.querySelectorAll('.crb-slide').length <= 1) return;
        clearInterval(interval);
        interval = setInterval(() => {
          const slides = container.querySelectorAll('.crb-slide');
          let current = 0;
          slides.forEach((s, i) => { if(s.classList.contains('active')) current = i; });
          window.crbChangeSlide(sectionId, current + 1);
        }, speed);
      };

      // 监听手动切换事件以重置计时器
      container.addEventListener('crbSlideUpdate', (e) => {
        currentIndex = e.detail.index;
        startTimer();
      });

      // 移动端滑动支持
      let startX = 0;
      container.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, {passive: true});
      container.addEventListener('touchend', e => {
        const diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) {
          let current = 0;
          container.querySelectorAll('.crb-slide').forEach((s, i) => { if(s.classList.contains('active')) current = i; });
          window.crbChangeSlide(sectionId, diff > 0 ? current + 1 : current - 1);
        }
      }, {passive: true});

      startTimer();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();